import { render, staticRenderFns } from "./supplier-add-or-update.vue?vue&type=template&id=d71d6936&scoped=true"
import script from "./supplier-add-or-update.vue?vue&type=script&lang=js"
export * from "./supplier-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./supplier-add-or-update.vue?vue&type=style&index=0&id=d71d6936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71d6936",
  null
  
)

export default component.exports